import { render, staticRenderFns } from "./PukupukuPage.vue?vue&type=template&id=b344f73c&scoped=true&"
import script from "./PukupukuPage.vue?vue&type=script&lang=js&"
export * from "./PukupukuPage.vue?vue&type=script&lang=js&"
import style0 from "./PukupukuPage.vue?vue&type=style&index=0&id=b344f73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b344f73c",
  null
  
)

export default component.exports